<template>
  <div class="page page--center">
    <h1 class="page__title">{{ page.title }}</h1>

    <article class="page__content">
      <content-editor v-model="page.description" :options="options" :controls="false"></content-editor>
    </article>

    <form @submit.prevent="sendSupportRequest" @keydown="form.onKeydown($event)" class="page__form page__form--partnership form" autocomplete="off">
      <h3 class="form__title">Форма обратной связи</h3>

      <alert-success :form="form" :message="status"></alert-success>

      <div class="form__field">
        <label class="form__label">Имя</label>
        <div class="form__input-wrapper">
          <input v-model="form.name"
                 v-validate="'required|min:3'"
                 type="text"
                 name="name"
                 autocomplete="off"
                 class="form__input"
                 :class="{'is-danger': errors.has('name') }">
          <span v-show="errors.has('name')" class="form__alert form__alert--error">{{ errors.first('name') }}</span>
        </div>
      </div>

      <div class="form__field">
        <label class="form__label">Ваш емейл</label>
        <div class="form__input-wrapper">
          <input v-model="form.email"
                 v-validate="'required|email'"
                 type="email"
                 name="email"
                 class="form__input"
                 :class="{'is-danger': errors.has('email') }">
          <span v-show="errors.has('email')" class="form__alert form__alert--error">{{ errors.first('email') }}</span>
        </div>
      </div>

      <div class="form__field form__field--text">
        <label class="form__label">Вопрос</label>
        <textarea v-model="form.description"
                  name="description"
                  class="form__textarea"></textarea>
      </div>

      <v-button :loading="form.busy" :disabled="form.busy" class="form__button button button--blue">Отправить заявку</v-button>
    </form>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ContentEditor from '../components/ContentEditor';
  import Form from 'vform';

  export default {
    components: {
      ContentEditor,
    },
    metaInfo () {
      return { title: 'Форма обратной связи' };
    },
    data: () => ({
      options: {
        postImageUrl: '',
        baseImagePath: '',
      },
      status: '',
      form: new Form({
        name: '',
        email: '',
        phone: '',
        description: '',
      }),
    }),
    computed: {
      ...mapGetters({
        page: 'pages/page',
      }),
    },
    methods: {
      async sendSupportRequest () {
        this.form.token = this.$route.params.token;

        const { data } = await this.form.post('/api/requests/support');

        this.status = data.status;
        this.form.reset();
      }
    },
    async beforeMount () {
      this.$store.dispatch('pages/clearPage');
      this.$store.dispatch('pages/find', 'support').then(() => {
        this.$store.dispatch('pages/stopLoading');
      });

      this.$store.dispatch('pages/setBreadcrumbs', [
        {
          title: 'Главная',
          route: { name: 'home' },
        },
        {
          title: 'Форма обратной связи',
        }
      ]);
      this.$store.dispatch('pages/setControls', [
        {
          url: '/admin/pages/support',
          label: 'Редактировать',
          roles: ['admin']
        }
      ]);
    }
  }
</script>
